import { BehaviorSubject, Observable, Subject } from "rxjs";
import { ApiService } from "./api.service";
import { candidateModel } from "./candidateModel";
import { Injectable } from "@angular/core";
import { responseObject } from "./UserService";
import { map } from 'rxjs/operators';
import { UtilService } from './util.service';
import { AppSettings } from './AppSettings';
import { FormBuilder, FormGroup } from "@angular/forms";
import { GigsumoService } from "./gigsumoService";

type paginate = "limit" | "pageNumber" | "userId" | "searchAfterKey";
@Injectable({
  providedIn : 'root'
})
export class CandidateService {
  private dataForFilterSubject = new BehaviorSubject<any>(null);
  private dataForReset = new Subject<boolean>();
  static FILTER_ELEMENT = ["all", "myCandidates", "marketPlaceCandidates", "teamCandidates", "benchNetworkCandidates", "freeLancerNetworkCandidates", "mtaNetworkCandidates",
    "jobSeekerNetworkCandidates", "featured", "suggestedCandidates" , "businessNetwork" , "memberNetworksCandidates" ];

  constructor(private api : ApiService,private util:UtilService , private formBuilder : FormBuilder){}


  updateCandidateViewed({candidateId}) : Observable<any>{
     let data : any = {};
     data.userId = localStorage.getItem('userId');
     data.candidateId = candidateId;
     return this.api.updatePut("candidates/updateCandidateViewed" , data);
  }

  updateCandidate(data : candidateModel) : Observable<any>{
      data.candidateReferenceId=data.candidateId;
      return this.api.updatePut('candidates/updateCandidate' , data);
  }

  findCandidatesInvitedByTheUser(data : Pick<responseObject,paginate>) : Observable<any>{
    return this.api.create("candidates/findCandidatesInvitedByTheUser" , data).pipe(
      map(response =>{ return response.data}));
  }

  getResumeRequestedUsers(data: Pick<responseObject, paginate>): Observable<any> {
    return this.api.create("candidates/findResumeRequestByTheUser", data).pipe(
      map(response => {
        // if (response.data && response.data.resumeRequests) {
          return response.data;
      })
    );
  }


  findActiveCandidates(data : Pick<responseObject,"userId" | "limit" | "searchAfterKey">) : Observable<any>{
    return this.api.create("candidates/findActiveCandidates",data).pipe(map(response=>{
      if(response.code != "00000"){
        throw new Error("There is some issue with Server");
      }
      if (response.data && response.data.candidateList) {

        response.data.candidateList.forEach(ele => {
          if (ele.user) {
            if (ele.user.photo != null) {
              ele.user.photo = AppSettings.photoUrl + ele.user.photo;
            } else {

              ele.user.photo = null;
            }
          }
        });

        response.data.candidateList = [...response.data.candidateList];
      }
      return  response.data;
    }));
  }

  getResumeViewsByTheUser(data : Pick<responseObject,"userId" | "limit" | "searchAfterKey">) : Observable<any>{

    return this.api.create("candidates/findCandidatesViewedByTheUser",data).pipe(map(response=>{
      this.util.stopLoader();
      if(response.code != "00000"){
        throw new Error("There is some issue with Server");
      }
      if (response.data && response.data.viewedCandidatesList) {

        response.data.viewedCandidatesList.forEach(ele => {
          if (ele.user) {
            if (ele.user.photo != null) {
              ele.user.photo = AppSettings.photoUrl + ele.user.photo;
            } else {

              ele.user.photo = null;
            }
          }
        });

        response.data.viewedCandidatesList = [...response.data.viewedCandidatesList];
      }
      return  response.data;
    }));
  }

  findByCandidateId(candidateId : string) {
    return this.api.query("candidates/findCandidateById/"+ candidateId).pipe(map(response=>{
      this.util.stopLoader();
      if(response.code != "00000"){
        throw new Error("There is some issue with Server");
      }
      return  response.data;
    }));
  }

  setDataForFilter(data: any): void {
    this.dataForFilterSubject.next(data);
  }

  getDataForFilter(): Observable<any> {
    return this.dataForFilterSubject.asObservable();
  }

  setReset(data: boolean): void {
    this.dataForReset.next(data);
  }

  getReset(): Observable<boolean> {
    return this.dataForReset.asObservable();
  }

  candidateSourcefields(dataArr : any[]): FormGroup {
    let data  = [
      "all",
      "myCandidates",
      "myEmployees",
      "marketPlaceCandidates",
      "teamCandidates",
      "benchNetworkCandidates",
      "freeLancerNetworkCandidates",
      "mtaNetworkCandidates",
      "jobSeekerNetworkCandidates",
      "businessNetwork",
      "memberNetworksCandidates",
      // "featured",
      // "suggestedCandidates",
    ].concat(dataArr.filter(
      c => !GigsumoService.FILTER_ITEMS('CANDIDATE').map(x => x.value).includes(c.networkName)
    ).map(x => x.networkId));

    let filterformGroup = {};
    data.forEach(x=>{
       filterformGroup[x] =  false;
    });

    return this.formBuilder.group(filterformGroup);
  }

}
